import { MouseEvent, useState } from 'react';
import { Box, Divider, Menu, MenuItem } from '@mui/material';

type MainProfileMenuProps = {
  profileLabel: string;
  canManageExternalKeys: boolean;
  canEditTheme: boolean;
  onNavigateProfile: () => void;
  onNavigateBilling: () => void;
  onNavigateArchived: () => void;
  onOpenExternalKeys: () => void;
  onEditTheme: () => void;
  onLogout: () => void;
};

export const MainProfileMenu = ({
  profileLabel,
  canManageExternalKeys,
  canEditTheme,
  onNavigateProfile,
  onNavigateBilling,
  onNavigateArchived,
  onOpenExternalKeys,
  onEditTheme,
  onLogout,
}: MainProfileMenuProps) => {
  const [profileMenuAnchor, setProfileMenuAnchor] = useState<HTMLElement | null>(null);

  const onProfileMenuOpen = (event: MouseEvent<HTMLElement>) => {
    setProfileMenuAnchor(event.currentTarget);
  };

  const onProfileMenuClose = () => {
    setProfileMenuAnchor(null);
  };

  const onProfileClick = () => {
    onProfileMenuClose();
    onNavigateProfile();
  };

  const onBillingClick = () => {
    onProfileMenuClose();
    onNavigateBilling();
  };

  const onArchivedClick = () => {
    onProfileMenuClose();
    onNavigateArchived();
  };

  const onExternalKeysClick = () => {
    onProfileMenuClose();
    onOpenExternalKeys();
  };

  const onEditThemeClick = () => {
    onProfileMenuClose();
    onEditTheme();
  };

  const onLogoutClick = () => {
    onProfileMenuClose();
    onLogout();
  };

  return (
    <>
      <Box
        component="button"
        type="button"
        onClick={onProfileMenuOpen}
        sx={{
          width: 45,
          height: 45,
          border: 0,
          borderRadius: '999px',
          bgcolor: '#e1386a',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          fontSize: 18,
          lineHeight: 1,
          cursor: 'pointer',
        }}
      >
        {profileLabel}
      </Box>
      <Menu
        anchorEl={profileMenuAnchor}
        open={Boolean(profileMenuAnchor)}
        onClose={onProfileMenuClose}
        slotProps={{
          paper: {
            sx: {
              borderRadius: '3px',
              boxShadow: '0 1px 4px #cccccc',
              minWidth: 190,
            },
          },
        }}
      >
        <MenuItem onClick={onProfileClick} sx={{ fontSize: 14, fontWeight: 700, py: 1, px: 1 }}>
          My Profile
        </MenuItem>
        <MenuItem onClick={onBillingClick} sx={{ fontSize: 14, fontWeight: 700, py: 1, px: 1 }}>
          Billing
        </MenuItem>
        {canManageExternalKeys ? <Divider /> : null}
        {canManageExternalKeys ? (
          <MenuItem
            onClick={onExternalKeysClick}
            sx={{ fontSize: 14, fontWeight: 700, py: 1, px: 1 }}
          >
            My External Keys
          </MenuItem>
        ) : null}
        <MenuItem onClick={onArchivedClick} sx={{ fontSize: 14, fontWeight: 700, py: 1, px: 1 }}>
          View Archived
        </MenuItem>
        {canEditTheme ? (
          <MenuItem onClick={onEditThemeClick} sx={{ fontSize: 14, fontWeight: 700, py: 1, px: 1 }}>
            Edit Theme
          </MenuItem>
        ) : null}
        <Divider />
        <MenuItem onClick={onLogoutClick} sx={{ fontSize: 14, fontWeight: 700, py: 1, px: 1 }}>
          Log Out
        </MenuItem>
      </Menu>
    </>
  );
};
